import { useTranslation } from 'react-i18next';
import { Flex, Spinner, Text } from '@/components/common';

interface LoadingStateProps {
  message?: string;
}

export function LoadingState({ message }: LoadingStateProps) {
  const { t } = useTranslation('common');

  return (
    <Flex align="center" justify="center" direction="column" gap="3" py="9">
      <Spinner />
      <Text size="2" color="gray">
        {message ?? t('loading.default')}
      </Text>
    </Flex>
  );
}

export type { LoadingStateProps };
